
    $.widget("ui.gallery", {
        options: {
            containerID: '',
            externalGalleryID: '',
            goTo: [],
            galleries: [],
            cacheImage: document.createElement('img'),
            imageSize: 'large',
            onNavigateClickCallbacks: [],
            onChangeCurrentImageCallbacks: [],
            useKeyEvents: false,
            galleryIndex: 0,
            imageIndex: 0,
        },
        _create: function() {
            var self = this, o = this.options;
            if (typeof(o.galleries) == 'string') {
                $.getJSON(o.galleries, '', function (data) {
                    o.galleries = data;
                    self._loadGallery();
                });
            } else if (o.galleries.length == 0) {
                self.element.hide();
            } else {
                self._loadGallery();
            }
        },
        _loadGallery: function () {
            var self = this, o = this.options;
            var image = '';
            o.theLoader = $('#' + o.loader);
            o.thumbContainers = self.element.find('.galleryThumbContainer');

            var counter = -1;
            $.each(o.galleries, function (index, value) {
                if (value.show == 0) {
                    return;
                };
                counter++;

                var thumbContainerImageIndex = index === o.galleryIndex ? o.imageIndex : 0;
                $(o.thumbContainers[counter])
                    .addClass('thumb'+index)
                    .data('image_index', thumbContainerImageIndex)
                    .find('.imageLink')
                    .data('index', index);
            });

            self.element.data('gallery_index', o.galleryIndex);
            self.element.data('image_index', o.imageIndex);
            self.element.data('discount', 'showDiscount');

            if (o.useKeyEvents) {
                self._activateKeys();
            }

            o.cookie = 'gallery_info';
            o.imageContainer = self.element.find(".galleryImageLarge");
            o.largeImage = self.element.find(".galleryImageLarge img");

            var galleryHeight = o.imageContainer.height();
            var largeImageHeight = o.largeImage.height();
            var topPosition =  (galleryHeight-largeImageHeight) / 2;
            o.largeImage.css('top', topPosition);

            o.largeImage.load(function () {
                galleryHeight = o.imageContainer.height();
                largeImageHeight = o.largeImage.height();
                topPosition =  (galleryHeight-largeImageHeight) / 2;

                o.largeImage.css('top', topPosition);
                self._setSelected();
                o.theLoader.hide();
            });

            self._checkNextImg(true);
            self._setGalleryInfo();
            o.cacheImage.src = o.galleries[self.element.data('preload_gallery_index')].images[self.element.data('preload_image_index')][o.imageSize];
            o.cacheImage.alt = o.galleries[self.element.data('preload_gallery_index')].images[self.element.data('preload_image_index')].alt;
            o.cacheImage.title = o.galleries[self.element.data('preload_gallery_index')].images[self.element.data('preload_image_index')].title;

            self.element.find('.galleryImageSliderPrevious').click(function (event) {
                event.preventDefault();
                o.theLoader.show();
                self._prevImg();
                self._setImageSliderNumber();
                self._setGalleryInfo();
            });

            self.element.find('.galleryImageSliderNext').click(function (event) {
                event.preventDefault();
                o.theLoader.show();
                self._nextImg();
                self._setImageSliderNumber();
                self._setGalleryInfo();
            });

            self.element.find('.imageLink').click(function (event) {
                o.theLoader.show();
                const thumbImageLink = $(this);
                const thumbContainer = thumbImageLink.parent();
                const thumbImage = thumbImageLink.children('img');
                const thumbNumber = thumbContainer.find('.galleryThumbNumber');

                if (thumbImageLink.data('index') != self.element.data('gallery_index')) {
                    thumbContainer.data('image_index', thumbContainer.data('image_index') - 1);
                }

                if (thumbContainer.data('image_index') == o.galleries[thumbImageLink.data('index')].images.length - 1) {
                    thumbContainer.data('image_index', -1);
                }

                thumbContainer.data('image_index', thumbContainer.data('image_index') + 1);
                thumbImage.prop('src', o.galleries[thumbImageLink.data('index')].images[thumbContainer.data('image_index')]['thumb']);
                thumbImage.prop('alt', o.galleries[thumbImageLink.data('index')].images[thumbContainer.data('image_index')]['alt']);
                thumbImage.prop('title', o.galleries[thumbImageLink.data('index')].images[thumbContainer.data('image_index')]['title']);
                thumbNumber.html((thumbContainer.data('image_index')+1) + '/' + o.galleries[thumbImageLink.data('index')].images.length);
                o.largeImage.prop('src', o.galleries[thumbImageLink.data('index')].images[thumbContainer.data('image_index')][o.imageSize]);
                o.largeImage.prop('alt', o.galleries[thumbImageLink.data('index')].images[thumbContainer.data('image_index')]['alt']);
                o.largeImage.prop('title', o.galleries[thumbImageLink.data('index')].images[thumbContainer.data('image_index')]['title']);
                self.element.data('gallery_index', thumbImageLink.data('index'));
                self.element.data('image_index', thumbContainer.data('image_index'));
                self.element.data('discount', thumbImageLink.data('discount'));

                if (o.largeImage[0].complete) {
                    o.largeImage.trigger('load');
                }

                self._setImageSliderNumber();
                self._setGalleryInfo();
                self._checkNextImg(true);
                o.cacheImage.src = o.galleries[self.element.data('preload_gallery_index')].images[self.element.data('preload_image_index')][o.imageSize];
                o.cacheImage.alt = o.galleries[self.element.data('preload_gallery_index')].images[self.element.data('preload_image_index')].alt;
                o.cacheImage.title = o.galleries[self.element.data('preload_gallery_index')].images[self.element.data('preload_image_index')].title;
                return false;
            });
        },
        _checkPrevImg: function (preload) {
            var self = this, o = this.options;
            var gallery_index = 'gallery_index',
                image_index = 'image_index';

            if (preload) {
                self.element.data('preload_gallery_index', self.element.data('gallery_index'));
                self.element.data('preload_image_index', self.element.data('image_index'));
                gallery_index = 'preload_gallery_index';
                image_index = 'preload_image_index';
            }

            if (self.element.data(image_index) == 0) {
                let n;
                if (self.element.data(gallery_index) == 0) {
                    n = o.galleries.length-1;
                } else {
                    n = self.element.data(gallery_index) - 1;
                }
                let i;
                for (i = n; i >= 0; i--) {
                    self.element.data(gallery_index,i);
                    if (o.galleries[self.element.data(gallery_index)].show != "0") {
                        break;
                    }
                }
                self.element.data(image_index, o.galleries[i]['images'].length - 1);
            } else {
                self.element.data(gallery_index, self.element.data(gallery_index));
                self.element.data(image_index, self.element.data(image_index) - 1);
            }
        },
        _prevImg: function () {
            var self = this, o = this.options;

            self._checkPrevImg();
            o.largeImage.prop('src', o.galleries[self.element.data('gallery_index')].images[self.element.data('image_index')][o.imageSize]);
            o.largeImage.prop('alt', o.galleries[self.element.data('gallery_index')].images[self.element.data('image_index')].alt);
            o.largeImage.prop('title', o.galleries[self.element.data('gallery_index')].images[self.element.data('image_index')].title);
            o.thumbContainers.each(function (index, value) {
                if ($(value).children('.imageLink').data('index') == self.element.data('gallery_index')) {
                    self.element.data('discount',$(value).children('.imageLink').data('discount'));
                    $(value).data('image_index', self.element.data('image_index'));
                    $(value).find('.imageLink img').prop('src', o.galleries[self.element.data('gallery_index')].images[self.element.data('image_index')].thumb);
                    $(value).find('.galleryThumbNumber').html((self.element.data('image_index')+1) + '/' + o.galleries[$(value).children('.imageLink').data('index')].images.length);
                    return false;
                }
            });

            self._checkPrevImg(true); //cache prev image
            o.cacheImage.src = o.galleries[self.element.data('preload_gallery_index')].images[self.element.data('preload_image_index')][o.imageSize];
            o.cacheImage.alt = o.galleries[self.element.data('preload_gallery_index')].images[self.element.data('preload_image_index')].alt;
            o.cacheImage.title = o.galleries[self.element.data('preload_gallery_index')].images[self.element.data('preload_image_index')].title;
        },
        _checkNextImg: function (preload) {
            var self = this, o = this.options;
            var gallery_index = 'gallery_index',
                image_index = 'image_index';

            if (preload) {
                self.element.data('preload_gallery_index', self.element.data('gallery_index'));
                self.element.data('preload_image_index', self.element.data('image_index'));
                gallery_index = 'preload_gallery_index';
                image_index = 'preload_image_index';
            }

            if (self.element.data(image_index) == o.galleries[self.element.data(gallery_index)].images.length - 1) {
                if (self.element.data(gallery_index) == o.galleries.length - 1) {
                   if (o.galleries[0].show == 0) {
                        $.each(o.galleries, function (key, value) {
                            if (value.show != 0) {
                                $.key = key;
                                return false;
                            }
                        })
                    } else {
                        $.key = 0;
                    }
                    self.element.data(gallery_index, $.key);
                } else {
                    for (let i = self.element.data(gallery_index); i <= o.galleries.length; i++) {
                        self.element.data(gallery_index, self.element.data(gallery_index) + 1);
                        if (o.galleries[self.element.data(gallery_index)] == undefined) {
                            self.element.data(gallery_index, 0);
                            break;
                        } else if (o.galleries[self.element.data(gallery_index)].show != false) {
                            break;
                        }
                    }
                }
                self.element.data(image_index, 0);
            } else {
                self.element.data(gallery_index, self.element.data(gallery_index));
                self.element.data(image_index, self.element.data(image_index) + 1);
            }
        },
        _nextImg: function () {
            var self = this, o = this.options;

            self._checkNextImg();
            o.largeImage.prop('src', o.galleries[self.element.data('gallery_index')].images[self.element.data('image_index')][o.imageSize]);
            o.largeImage.prop('alt', o.galleries[self.element.data('gallery_index')].images[self.element.data('image_index')].alt);
            o.largeImage.prop('title', o.galleries[self.element.data('gallery_index')].images[self.element.data('image_index')].title);

            o.thumbContainers.each(function (index, value) {
                if ($(value).children('.imageLink').data('index') == self.element.data('gallery_index')) {
                    self.element.data('discount',$(value).children('.imageLink').data('discount'));
                    $(value).data('image_index', self.element.data('image_index'));
                    $(value).find('.imageLink img').prop('src', o.galleries[self.element.data('gallery_index')].images[self.element.data('image_index')].thumb);
                    $(value).find('.galleryThumbNumber').html((self.element.data('image_index')+1) + '/' + o.galleries[$(value).children('.imageLink').data('index')].images.length);
                    return false;
                }
            });

            self._checkNextImg(true); //cache next image
            o.cacheImage.src = o.galleries[self.element.data('preload_gallery_index')].images[self.element.data('preload_image_index')][o.imageSize];
            o.cacheImage.alt = o.galleries[self.element.data('preload_gallery_index')].images[self.element.data('preload_image_index')].alt;
            o.cacheImage.title = o.galleries[self.element.data('preload_gallery_index')].images[self.element.data('preload_image_index')].title;
        },
        _goTo: function (gIndex, iIndex, image) {
            var self = this, o = this.options;
            if (image === undefined) {
                self.element.data('gallery_index', gIndex);
                self.element.data('image_index', iIndex);
                image = o.galleries[gIndex].images[iIndex][o.imageSize];
            }
            o.largeImage.prop('src', image).trigger('load');

            o.thumbContainers.each(function (index, value) {
                if ($(value).children('.imageLink').data('index') == gIndex) {
                    self.element.data('discount',$(value).children('.imageLink').data('discount'));
                    $(value).data('image_index', iIndex);
                    $(value).find('.imageLink img').prop('src', o.galleries[gIndex].images[iIndex].thumb);
                    $(value).find('.galleryThumbNumber').html((iIndex+1) + '/' + o.galleries[$(value).children('.imageLink').data('index')].images.length);
                    return false;
                }
            });

            self._setImageSliderNumber();
            self._setGalleryInfo();
        },
        _setSelected: function () {
            var self = this, o = this.options;
            o.thumbContainers.removeClass('active');
            // Postavljamo active thumb
            self.element.find('.thumb' + self.element.data('gallery_index')).addClass('active');
            self._executeChangeCurrentImageCallbacks(
                o.onChangeCurrentImageCallbacks,
                parseInt(this.element.data('gallery_index'), 10),
                parseInt(this.element.data('image_index'), 10)
            );
            self._executeNavigateCallbacks(o.onNavigateClickCallbacks);
        },
        _activateKeys: function () {
            var self = this, o = this.options;
            $(document).on('keydown', function (e) {
                if(e.keyCode == 37) { // left arrow
                    e.preventDefault();
                    o.theLoader.show();
                    self._prevImg();
                    self._setImageSliderNumber();
                    self._setGalleryInfo();
                } else if (e.keyCode == 39) { // right arrow
                    e.preventDefault();
                    o.theLoader.show();
                    self._nextImg();
                    self._setImageSliderNumber();
                    self._setGalleryInfo();
                }
            });
        },
        _setImageSliderNumber: function () {
            var self = this;
            var o = this.options;
            var numberOfImages = o.galleries[self.element.data('gallery_index')].images.length;
            var position = parseInt(this.element.data('image_index'), 10) + 1;
            this.element.find('.galleryImageSliderNumber')
                .html('<span class="bold">' + o.galleries[this.element.data('gallery_index')].name + ' </span> <span class="albumPos">(' + position + '/' + numberOfImages + ')</span>');
        },
        _setGalleryInfo: function () {
            const self = this, o = this.options;
            const partDescriptionRows = o.galleries[self.element.data('gallery_index')].partDescriptionRows;

            if (partDescriptionRows === undefined) {
                var info = o.galleries[self.element.data('gallery_index')].info;
            }

            if (self.options.galleries[self.element.data('gallery_index')].showDiscount == false ) {
                self.element.addClass('noDiscount');
            } else if (self.options.galleries[self.element.data('gallery_index')].showDiscount == true ) {
                self.element.removeClass('noDiscount');
            }

            if (partDescriptionRows !== undefined && partDescriptionRows.length === 0) {
                self.element.find('.galleryImageInfo').hide();
                return false;
            } else if (partDescriptionRows === undefined && info == null || info == '') {
                self.element.find('.galleryImageInfo').hide();
                return false;
            } else {
                self.element.find('.galleryImageInfo').show();
            }

            if (self.element.find('.galleryImageInfo').length == 0) {
                var tmpCookie = $.cookie(o.cookie);
                if (tmpCookie == '1' || tmpCookie == null ) {
                    self.element.find('.galleryImageLarge').addClass('notAligned');
                } else {
                    self.element.find('.galleryImageLarge').removeClass('notAligned');
                }
                $('<div class="galleryImageInfo"></div>').append(
                    $('<div />').addClass(tmpCookie == '0' ? 'galleryImageIcons' : 'galleryImageIcons getIn').append(
                        $('<a />').addClass(tmpCookie == '0' ? 'galInfo' : 'galInfoOff').click(function (event) {
                            event.preventDefault();
                            self.element.find('.imgDesc').slideToggle();
                            $(this).toggleClass('galInfoOff galInfo').parent().toggleClass('getIn');
                            $.cookie(o.cookie, $.cookie(o.cookie) == '0' ? '1' : '0', { path: '/', expires: 0 });
                            if ($.cookie(o.cookie) == '1') {
                                self.element.find('.galleryImageLarge').addClass('notAligned');
                            } else {
                                self.element.find('.galleryImageLarge').removeClass('notAligned');
                            }
                        })
                    )
                ).append(
                    $('<div class="imgDesc galleryImageDescription"></div>').css( "display", tmpCookie == '0' ? "none;" : "block")
                ).prependTo(self.element.find('.galleryImageLargeContainer'));
            }

            if ($.cookie(o.cookie)=='0') {
                self.element.find('.imgDesc').hide();
            } else {
                self.element.find('.imgDesc').show();
            }

            const imageDescriptionElement = self.element.find('.imgDesc').html('');
            if (partDescriptionRows === 'undefined') {
                $.each(info, function(index, value) {
                    if (index == 'heading') {
                        imageDescriptionElement.append($('<strong />').append(value)).append('<br>');
                    } else {
                        $('<strong />').append(index).appendTo(imageDescriptionElement);

                        if (value) {
                            imageDescriptionElement.append(': ' + value);
                        }
                        imageDescriptionElement.append('<br>');
                    }
                });
            } else {
                partDescriptionRows.forEach(row => imageDescriptionElement.append(row).append('<br>'));
            }
        },
        _executeNavigateCallbacks: function (callbacks) {
            callbacks.map(function (callback) {
                callback();
            });
        },
        _executeChangeCurrentImageCallbacks: function (callbacks, galleryIndex, imageIndex) {
            callbacks.map(function (callback) {
                callback(galleryIndex, imageIndex);
            });
        },
    });
